import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=e757878e&scoped=true&lang=html&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e757878e",
  null
  
)

export default component.exports